module.exports = __webpack_public_path__ + "static/img/sha.4b26182.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sha.png
// module id = ZU62
// module chunks = 26